import { Injectable, Injector } from '@angular/core';

import {LogService} from "./core/logger/logger_service"

@Injectable()
export class BaseComponents {
    protected logger;
    constructor(protected injectorObj:Injector) { 
     this.logger = this.injectorObj.get(LogService);
    }
}